export enum AUTH {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  AUTHENTIFICATE = 'AUTHENTIFICATE',
  DISMISS_AUTHENTIFICATE = 'DISMISS_AUTHENTIFICATE',
}

interface State {
  isLoggedIn: boolean;
  isAuthentificated: boolean;
}

type Action = { type: AUTH };

export const authReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case AUTH.LOGIN:
      return {
        ...state,
        isLoggedIn: true,
      };
    case AUTH.LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
      };
    case AUTH.AUTHENTIFICATE:
      return {
        ...state,
        isAuthentificated: true,
      };
    case AUTH.DISMISS_AUTHENTIFICATE:
      return {
        ...state,
        isAuthentificated: false,
      };

    default:
      return state;
  }
};
